export const GAMES_WIDGET = {
  GROUPS_ORDER: {
    byDate: 0,
    byGroup: 1,
  }
}